import { h, Component } from 'preact';
import Loadable from 'react-loadable';
import axios from 'axios';

import { Search as SearchIcon } from '../icons/searchIcons';
import showOrHide from '../hoc/showOrHide';
import { getCurrentCity } from '../../helpers';
import { getEventTrackGA } from '../../helpers/ga';
import MediaQuery from '../../hoc/mediaQuery';

import QuikrWallet from '../icons/drawerIcons/wallet';
import Cookies from 'universal-cookie';
import { ABRAND_COOKIE_KEY, WALLET_REDIRECTION_CONSTANT } from '../../helpers/constants';

// import Popup from '../pageLayer';
import styles from './index.scss';


const axiosInstance = axios.create({
	baseURL: 'https://www.quikr.com/',
	timeout: 1000,
	headers: {
		accept: 'application/json, text/javascript, */*; q=0.01',
		'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
		'Content-Type': 'application/x-www-form-urlencoded',
		'X-Requested-With': 'XMLHttpRequest'
	}
});

const LoadableSearchPopup = Loadable({
	loader: () => import('./searchPopup'),
	loading: () => <div />,
	render(loaded, props) {
		let SearchPopup = loaded.default;
		return <SearchPopup {...props} />;
	}
});

const cookies = new Cookies();

class Search extends Component {

	constructor(props) {
		super(props);
		this.state = {
			popup: false,
			walletBalance: 0,
			showBalance: false,
			walletCall: false,
			backdrop: true
		};
	}

	componentDidMount() {
		this.doWalletCall();
	}

	getWalletListener = () => {
		document.body.addEventListener("apiCall", () => {
			if (!this.state.walletCall) {
				this.getWalletBalance();
			}
		}
		);
	}
	getWalletBalance = () => {
		this.setState({ 'walletCall': true });
		const { wallet = true } = this.props;
		if (wallet) {
			axiosInstance.get(`https://www.quikr.com/core/quikrcom/pwa_api/get-wallet-balance`).then((res) => {
				if (res.status === 200) {
					let amount = res.data.walletBalance;
					this.setState({
						walletBalance: amount
					});
					this.props.updateWalletBalance(amount);
					if (res.data.walletBalance != -1) {
						this.setState({
							showBalance: true
						});
					}
				}
			}).catch(e => { });

		}
	}
	/**
* This method is called whenever the props or state changes
* @return {Object} Context of child components
*/
	getChildContext() {
		const context = {};
		context.pageType = this.getPageTypeFromProps();
		return context;
	}

getPageTypeFromProps = () => {
	const { getPageType } = this.props;
	if (typeof getPageType === 'function' && typeof window !== 'undefined') {
		return getPageType();
	}
	return 'other';
}

showPopup = () => {
	this.setState({
		popup: true,
		backdrop: false
	});
	const pageType = this.getPageTypeFromProps();
	const gaEventObject = { category: 'quikr_pwa', action: `quikr_pwa_${pageType}_search`, label: `quikr_pwa_${pageType}_search_focus` };
	getEventTrackGA(gaEventObject);
}

closePopup = () => {
	this.setState({
		popup: false,
		backdrop: true
	});
}

handleInput = (event) => {
	if (this.searchPopupRef) {
		// console.log("searchpopupref ", this.searchPopupRef._component.setValueAndSearch);
		this.searchPopupRef._component.setValueAndSearch(event);
	}
}

getPlaceholder = (prefix = 'Search') => `${prefix} In ${getCurrentCity()}`;

getpPerformanceFromProps = () => {
	const { pPerformance } = this.props;
	if (typeof pPerformance !== 'undefined') {
		return pPerformance;
	}
	return false;
	
}
getsearchtermFromProps = () => {
	const { searchterm } = this.props;
	if (typeof searchterm === 'function') {
		return searchterm();
	}
	return "";

}

redirectToWalletPage = () => {
	const abRand = cookies.get(ABRAND_COOKIE_KEY) || Math.random() * 100;
	if (Number(abRand) <= WALLET_REDIRECTION_CONSTANT) {
		window.location.href = 'https://www.quikr.com/wallet';
	} else {
		window.location.href = 'https://www.quikr.com/Escrow/MyOffers/cashbalance';
	}
}


renderWallet = () => {
	const isLoggedIn = this.props.userInfo && this.props.userInfo.loggedIn;
	const { state } = this;
	let className;
	if (this.state.walletBalance != -1) {
		className = '₹' + state.walletBalance;
	}
	return isLoggedIn && state.showBalance ? (<aside onClick={e => this.redirectToWalletPage()}>
		<i class="badge" data-badge={className}>
			<QuikrWallet class="action-box__icons" />
		</i>
	</aside>) : (<aside onClick={e => this.redirectToWalletPage()}>
		<i class="badge">
			<QuikrWallet class="action-box__icons" />
		</i>
	</aside>);
}

doWalletCall = () => {
	if (this.getpPerformanceFromProps()) {
		this.getWalletListener();
	} else {
		let self = this;
		setTimeout(() => {
			self.getWalletBalance();
		}, 5000);
	}
}

render(props, state, context) {
	const {
		placeholder = this.getPlaceholder(),
		onSearchCallback,
		searchSuggestions,
		onSearchSubmit,
		onRecentSearchClick,
		onTrendingSearchClick,
		showTrendingSearches,
		showRecentSearches,
		showDefaultSuggestion,
		wallet = true
	} = props;
	const searchterm = this.getsearchtermFromProps();
	const { popup } = state;

	return (
		<div>
			<div class="toolbar-search__wrapper">
				<form class="toolbar-search">
					<div class="toolbar-search__child">
						<span class="search-btn">
							<SearchIcon class="toolbar-search__icon" />
						</span>
						<MediaQuery minWidth={840} className="toolbar-search__box-desk">
							<input aria-label="search-box" class="toolbar-search__field" type="text" placeholder={searchterm !== "" ? searchterm : placeholder} onClick={this.showPopup} onInput={this.handleInput} />
						</MediaQuery>
						<MediaQuery maxWidth={840} className="toolbar-search__box">
							<input aria-label="search-box" class="toolbar-search__field" type="text" placeholder={searchterm !== "" ? searchterm : placeholder} onClick={this.showPopup} />
						</MediaQuery>
						<MediaQuery maxWidth={840} className="action-box">
							{wallet && this.renderWallet()}
						</MediaQuery>

					</div>
				</form>
				{popup &&
					<LoadableSearchPopup
						ref={(ref) => { this.searchPopupRef = ref; }}
						show
						closePopup={this.closePopup}
						placeholder={placeholder}
						onSearchCallback={onSearchCallback}
						searchSuggestions={searchSuggestions}
						onSearchSubmit={onSearchSubmit}
						onRecentSearchClick={onRecentSearchClick}
						onTrendingSearchClick={onTrendingSearchClick}
						showRecentSearches={showRecentSearches}
						showTrendingSearches={showTrendingSearches}
						showDefaultSuggestion={showDefaultSuggestion}
					/>}

			</div>
			{!this.state.backdrop && (<div class="suggester-overlay" onClick={this.closePopup} />)}
		</div>
	);
}
}

export default showOrHide(Search);



// WEBPACK FOOTER //
// ../q-components/components/search/index.js